Promise.all([
  import(/* webpackMode: "eager" */ './park-summary-tabs.scss'),
  import('../tab-park-info/tab-park-info'),
  import('../tab-see-and-do/tab-see-and-do'),
  /*import('../reviews/reviews'), // Reviews tab commented out*/
  import('../groups-functions/groups-functions'),
  import('../tab-current-deals/tab-current-deals'),
]).then(() => {
  $('.widget.park-summary-tabs').each(function (i, el) {
    $(el).data('widget', new ParkSummaryTabs(el))
    $(el).data('widget').init()
  })
})

function ParkSummaryTabs(el) {
  const self = this
  self.el = $(el)

  self.tabsToLoad = 2
  self.tabsLoaded = 0

  self.lastActiveTabName = ''

  self.updateUrlWithTab = function (name, title) {
    // Update the page title
    document.title = title

    // Append the tab name to the URL path
    //
    // '0/     1      /   2   /   3    /   4  /  5  '
    // '/caravan-parks/{state}/{region}/{slug}/{tab}'
    let segments = window.location.pathname.split('/')
    segments[5] = name // Adds tab name in 5th position of path segments

    const pathname = segments.join('/')

    let params = new URLSearchParams(window.location.search)
    params.delete('tab')

    const url = window.location.origin + pathname + '?' + params.toString()

    history.pushState(null, title, url)
  }

  self.setAllTabsNotActive = function () {
    self.el.find('.tab-container .tab').removeClass('active')
    self.el.find('.accordion-heading').removeClass('active')
    self.el.find('.tab-content').removeClass('active')
  }

  self.setTabActive = function (name) {
    self.setAllTabsNotActive()
    // If name empty or 'features' (which should only show on mobile), then show the first tab as active
    if (name === '' || name === 'features') {
      const firstTab = self.el.find(`.tab-container .tab[data-tab]`).first()
      name = firstTab.attr('data-tab')
    }

    ////Sets the active tab if a tab name is included in the base url.
    let tabs = self.el.find(`.tab-container .tab[data-tab]`)
    const defaultTab = 'park-info'
    let hasMatch = false
    $(tabs).each(function (tab) {
      let current_tab = $(tabs[tab])

      var path = window.location.pathname;
      let current_tab_name = current_tab.attr('data-tab');
      if (path.match('/' + current_tab_name)) {
        name = current_tab_name;
        hasMatch = true;
      }
    })

    if (!hasMatch) {
      name = defaultTab;
      const firstTabTitle = self.el.find('.accordion-heading[data-tab="park-info"]').attr('data-title');
      self.updateUrlWithTab(name, firstTabTitle)
    }

    self.el.find(`.tab-container .tab[data-tab="${name}"]`).addClass('active')
    self.el.find(`.accordion-heading[data-tab="${name}"]`).addClass('active')
    self.el.find(`.tab-content[data-tab='${name}']`).addClass('active')
  }

  self.removeTab = function (name)
  {

    self.el.find(`.tab-container .tab[data-tab="${name}"]`).remove();
    self.el.find(`.accordion-heading[data-tab="${name}"]`).remove();
  }

  self.reloadTab = function (name) {
    self.el.find(`.tab-container .tab[data-tab="${name}"]`).css('display', 'block');
    self.el.find(`.tab-content[data-tab='${name}']`)
      .addClass('active');

  }


  const displayAsTabs = function () {
    self.setTabActive(self.lastActiveTabName)
  }

  self.initTabs = function () {
    self.setAllTabsNotActive()
    let shouldLoadFirstTab = false
    let tabs = self.el.find(`.tab-container .tab[data-tab]`)

    //check if there is a selected tab base from url segments
    let lastUrlSegment = window.location.pathname.split("/").pop()
    if ($(".tab-container .tab[data-tab='" + lastUrlSegment + "']").length)
    {
      self.setTabActive(lastUrlSegment) // Ensures tab or accordion is expanded on page load
      shouldLoadFirstTab = false
      return false // exit loop
    }


    $(tabs).each(function (tab) {
      let $tab = $(tabs[tab])
      if ($tab.hasClass('active')) {
        self.lastActiveTabName = $tab.attr('data-tab')

        self.setTabActive(self.lastActiveTabName) // Ensures tab or accordion is expanded on page load
        shouldLoadFirstTab = false
        return false // exit loop
      }

      shouldLoadFirstTab = true
    })

    const shouldDisplayAsTabs = window.matchMedia('(min-width: 1600px)')

    if (shouldLoadFirstTab && shouldDisplayAsTabs.matches) {
      const $firstTab = $(tabs[0])
      const firstTabName = $firstTab.attr('data-tab')
      console.log('firstTabName:', firstTabName)
      self.setTabActive(firstTabName)
    }

    shouldDisplayAsTabs.addEventListener('change', function (media) {
      if (media.matches) {
        displayAsTabs()
      }
    })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ParkSummaryTabs init', self)
    }

    // When tab is clicked
    self.el.find('.tab-container .tab').click(function (event) {
      event.preventDefault()

      const $tab = $(this)
      const name = $tab.attr('data-tab')
      const pageTitle = $tab.attr('data-title')

      self.updateUrlWithTab(name, pageTitle)
      self.setTabActive(name)

      self.lastActiveTabName = name
    })

    // When accordion heading is clicked
    self.el.find('.accordion-heading').click(function (event) {
      event.preventDefault()

      const $accordionHeading = $(this)
      const name = $accordionHeading.attr('data-tab')
      const pageTitle = $accordionHeading.attr('data-title')
      // toggle open/closed the accordion
      $accordionHeading.toggleClass('active')
      $accordionHeading.parents('.park-summary-tabs').find(`.tab-content[data-tab='${name}']`).toggleClass('active')

      if ($accordionHeading.hasClass('active')) {
        self.lastActiveTabName = name
      } else {
        self.lastActiveTabName = ''
      }

      self.updateUrlWithTab(name, pageTitle)

      if (self.el.find('.tab-content .features').length) {
        let widest = 0

        self.el.find('.feature').each(function (i, el) {
          const thisWidth = $(this).outerWidth()
          if (thisWidth > widest) {
            widest = thisWidth
          }

          if ($(window).width() > 1024) {
            $(el).find('.icon').popup({
              on: 'hover',
              position: 'top left',
            })
          }
        })
        if (widest !== 0) self.el.find('.feature').css('width', widest)
      }
    })

    window.dbs.globalEvents.subscribe('remove_tab', function (name) {
      self.removeTab(name)
      self.setTabActive(name)
    })

    window.dbs.globalEvents.subscribe('reload_tab', function (name) {
      self.reloadTab(name);
    })


    // Keep track of how many tabs we need loaded before we show this widget on the page.
    // This allows us to avoid displaying tabs with empty content, because the content is being
    // requested by an endpoint or other dynamic source.
    window.dbs.globalEvents.subscribe('tab_loaded', function () {
      self.tabsLoaded++
      if (self.tabsLoaded >= self.tabsToLoad) {
        self.initTabs()
      }
      self.el.css('opacity', 1)
    })

    // emit 'was_tab_loaded' is used to double-check if any tabs were loaded before this script was init.
    // In which case, would mean we did not count that loaded tab as loaded, and this would then fail to
    // init the tabs via the subscribe 'tab_loaded' event, causing this widget to now show on the page.
    window.dbs.globalEvents.emit('was_tab_loaded', null, true)
  }
}
